import React, {Component} from 'react';
import {Link} from "react-router-dom";
import '../FaqPages/Shipping.css'
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'

class ShippingTopics extends React.Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3 className="inline-block-element"><b>出荷について</b></h3>
                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 配送業者を教えてください。</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 配送時間の指定はできますか？</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 受付日確定後ですが、配送先の変更はできますか？</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("d")}>
                        <Link to='/shipping'>
                            <h4> <b className="reduce-font-size cart-row-text-color">出荷予定日より早く出荷されることはありますか？</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 送料はいくらですか？</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e2")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color">商品が届きません。商品の配送情報を確認したいです。</b>
                            </h4>

                        </Link>

                    </div>

                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("f")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 出荷の連絡はいただけますか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("g")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> お届け先住所を変更したいのですが可能ですか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("h")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 海外への出荷はできますか？</b>
                            </h4>

                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("i")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 別々のカートで注文した商品を同梱して出荷することは可能ですか？</b>
                            </h4>
                        </Link>

                    </div>



                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("j")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 出荷日とは何ですか？</b>
                            </h4>
                        </Link>

                    </div>


                    <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("k")}>
                        <Link to='/shipping'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 複数箇所への配送はできますか？</b>
                            </h4>
                        </Link>

                    </div>

                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
                </div>

        );
    }
}

export default ShippingTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/ShippingTopics.js